import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Plus, CaretDown, House, Truck } from "@phosphor-icons/react";

/* The three ways to add a quote — same options as the Job Request page. builderLink = "/quotes/new?job_id=..." */
export function quoteOptions({ navigate, builderLink, onQuick }) {
  return [
    { key: "supplier", icon: <Truck size={14} className="mr-2 text-blue-600" />, title: "Add Supplier Quote", hint: "Full line-by-line quote with a linked supplier", run: () => navigate(`${builderLink}&source_type=supplier`) },
    { key: "in-house", icon: <House size={14} className="mr-2 text-emerald-600" />, title: "Create In-House Quote", hint: "Build a quote with line items", run: () => navigate(builderLink) },
    { key: "quick", icon: <Plus size={14} className="mr-2 text-slate-500" />, title: "Quick supplier quote", hint: "Just paste an amount (no line items)", run: onQuick },
  ];
}

export function AddQuoteMenu({ builderLink, onQuick, testPrefix, size = "sm" }) {
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size={size} data-testid={`${testPrefix}-add-quote-btn`}><Plus size={14} className="mr-1" /> Add Quote <CaretDown size={11} className="ml-1" /></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {quoteOptions({ navigate, builderLink, onQuick }).map(o => (
          <DropdownMenuItem key={o.key} onClick={o.run} data-testid={`${testPrefix}-add-quote-${o.key}`}>
            {o.icon}<div><p className="text-xs font-medium">{o.title}</p><p className="text-[10px] text-muted-foreground">{o.hint}</p></div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/* Shown straight after a sub-job is created when "Then add a quote" was ticked. */
export function AddQuoteChoiceDialog({ job, open, onOpenChange }) {
  const navigate = useNavigate();
  if (!job) return null;
  const opts = quoteOptions({ navigate, builderLink: `/quotes/new?job_id=${job.id}`, onQuick: () => navigate(`/jobs/${job.id}?quote=quick`) });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="sub-job-quote-choice">
        <DialogHeader>
          <DialogTitle className="font-[Chivo]">Add a quote for {job.reference}</DialogTitle>
          <DialogDescription>{job.title} — pick how you want to capture the price. You can add more quotes later from the sub-job's Quotes section.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {opts.map(o => (
            <button key={o.key} type="button" onClick={() => { onOpenChange(false); o.run(); }} className="flex items-center gap-3 rounded-md border border-border px-3 py-2.5 text-left hover:border-primary/50 hover:bg-muted/40 transition-colors" data-testid={`sub-job-quote-choice-${o.key}`}>
              {o.icon}<div><p className="text-sm font-medium">{o.title}</p><p className="text-[11px] text-muted-foreground">{o.hint}</p></div>
            </button>
          ))}
          <Button variant="ghost" size="sm" className="mt-1" onClick={() => onOpenChange(false)} data-testid="sub-job-quote-choice-skip">Skip for now</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
